export default "__VITE_ASSET__CTFChcbu__"